import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'
import { I1091Form } from 'legacy/lut/features/partner360/basicInfo'

import { jbpBasicInfoDataSource } from './configs'
import { getJBPBasicInfoCrud } from './helpers/getJBPBasicInfoCrud'
import { map1091ToBasicInfo } from './mappings/map1091ToBasicInfo'

interface IUpdatePartnerBasicInfo extends Omit<I1091Form, 'EntryId'> {
  ProgramType: ProgramTypes | null
}

export const updatePartnerBasicInfo = async (dataToUpdate: IUpdatePartnerBasicInfo) => {
  const crud = getJBPBasicInfoCrud()
  const [updatedItem] = await crud.update(jbpBasicInfoDataSource, [dataToUpdate])
  return map1091ToBasicInfo(updatedItem)
}
